import { Tag } from '@loadsmart/loadsmart-ui'
import { Card, CardContent, Stack, Box, Link, Typography } from '@mui/material'
import { Person } from '@mui/icons-material'
import { ConnectionSetting } from 'common/types/kraken-core/ConnectionSettings'
import { ROUTES } from 'routing/routes'

interface ConnectionSettingsCardProps {
  connection: ConnectionSetting
  getOwnerName: (conn: ConnectionSetting) => string
}

export default function ConnectionSettingsCard({
  connection,
  getOwnerName,
}: ConnectionSettingsCardProps) {
  return (
    <Card elevation={1}>
      <CardContent>
        <Stack spacing={2}>
          <Box display="flex" justifyContent="space-between" alignItems="flex-start">
            <Link
              href={`${ROUTES.CONNECTIONS}/${connection.id}`}
              target="_blank"
              rel="noopener noreferrer"
              sx={{
                color: 'primary.main',
                textDecoration: 'none',
                fontWeight: 'bold',
                fontSize: '1.1rem',
                '&:hover': {
                  textDecoration: 'underline',
                },
              }}
            >
              {connection.name}
            </Link>
            {connection.is_active ? (
              <Tag variant="accent">Active</Tag>
            ) : (
              <Tag variant="warning">Inactive</Tag>
            )}
          </Box>

          <Box display="flex" gap={1} alignItems="center">
            <Tag variant="default" size="small">
              {connection.protocol}
            </Tag>
          </Box>

          <Box>
            <Typography variant="caption" color="text.secondary" sx={{ mb: 0.5, display: 'block' }}>
              Owner
            </Typography>
            <Box
              display="flex"
              gap={1}
              alignItems="center"
              sx={{
                padding: 1,
                backgroundColor: 'grey.50',
                borderRadius: 1,
                border: '1px solid',
                borderColor: 'grey.200',
              }}
            >
              <Person fontSize="small" color="action" />
              <Typography variant="body2" color="text.primary" fontWeight="medium">
                {getOwnerName(connection)}
              </Typography>
            </Box>
          </Box>
        </Stack>
      </CardContent>
    </Card>
  )
}
